import { useState, useEffect, type FC } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavLink {
  label: string;
  href: string;
}

const navLinks: NavLink[] = [
  { label: '首页', href: '/' },
  { label: '平台介绍', href: '/category/platform-intro' },
  { label: '使用指南', href: '/category/user-guide' },
  { label: '资源中心', href: '/category/resources' },
  { label: '常见问题', href: '/category/faq' },
  { label: '关于我们', href: '/about' },
];

const Navbar: FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2">
          <span className="text-xl font-bold text-foreground-950 font-heading whitespace-nowrap">
            17c.com
          </span>
        </Link>

        <ul className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const isActive =
              link.href === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(link.href);
            return (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className={`px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                    isActive
                      ? 'text-primary-600 bg-primary-50'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            );
          })}
        </ul>

        <div className="hidden md:flex items-center gap-2">
          <Link
            to="/category/user-guide"
            className="px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors duration-200 cursor-pointer"
          >
            登录
          </Link>
          <Link
            to="/category/user-guide"
            className="px-5 py-2 rounded-md text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            免费注册
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="切换菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <ul className="flex flex-col px-4 py-3 gap-1">
            {navLinks.map((link) => {
              const isActive =
                link.href === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.href);
              return (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className={`block px-4 py-3 rounded-md text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                      isActive
                        ? 'text-primary-600 bg-primary-50'
                        : 'text-foreground-700 hover:bg-background-100'
                    }`}
                  >
                    {link.label}
                  </Link>
                </li>
              );
            })}
            <div className="flex gap-2 mt-2 pt-3 border-t border-background-200/70">
              <Link
                to="/category/user-guide"
                className="flex-1 text-center px-4 py-3 rounded-md text-sm font-medium whitespace-nowrap text-foreground-700 bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
              >
                登录
              </Link>
              <Link
                to="/category/user-guide"
                className="flex-1 text-center px-4 py-3 rounded-md text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
              >
                免费注册
              </Link>
            </div>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;